import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { AlertProvider } from '../../providers/alert/alert';
import { LoadingProvider } from '../../providers/loading/loading';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { Http } from '@angular/http';
import { TranslateService } from '@ngx-translate/core';
import { ProductDetailPage } from '../product-detail/product-detail';
import { CompleteInstallPage } from '../complete-install/complete-install';
import { DatePicker } from '@ionic-native/date-picker';
import swal from 'sweetalert';

@Component({
  selector: 'survey-detail',
  templateUrl: 'survey-detail.html',
})
export class SurveyDetailPage {
  order: { [k: string]: any } = {};
  finance = {};
  constructor(
    public navCtrl: NavController,
    public config: ConfigProvider,
    public navParams: NavParams,
    public http: Http,
		translate: TranslateService,
    public shared: SharedDataProvider,
    public alert: AlertProvider,
    public loading: LoadingProvider,
		public datePicker: DatePicker) {
    this.order = this.navParams.get('data');
    //console.log(this.order);
  }

  ionViewDidLoad() {
    this.order = this.navParams.get('data');
		console.log("Survey Details:",this.order)


  }

}



// WEBPACK FOOTER //
// ./src/pages/survey-detail/survey-detail.ts